import { useAbTestComponent, loadUsualComponent, loadLazyComponent } from "@hook";
import { inject, observer } from "mobx-react";

import AB_2771 from "./AB_2771";
import AB_3156 from "./AB_3156";
import Default from "./Default";

const abTests = {
    dev_3156__v2: loadUsualComponent(AB_3156),
    dev_2771__v2: loadUsualComponent(AB_2771),
    dev_3274__v2: loadLazyComponent(() => import("./AB_3274")),
    dev_3632__v2: loadLazyComponent(() => import("./AB_3274")),
};

const Geolocation = inject("mainStore")(
    observer(({ mainStore, ...props }) => {
        const init = mainStore.getMainStore("init");
        const Specified = useAbTestComponent({ init, abTests, defaultComponent: Default });

        return <Specified {...props} />;
    }),
);

export default Geolocation;
